/**
 * app/(marketing)/_layout.tsx - getabeam.com MARKETING SITE route group (web-only, public).
 *
 * This is the public website for the Beam product itself: marketing landing, pricing/account
 * creation, app downloads, and the entry point to the web-app login. It is intentionally separate
 * from any per-tenant company website wiring (see /WEBSITE-BUILD-PLAN.md). Do not conflate.
 *
 * The root AuthGate (app/_layout.tsx) keeps this surface public on web and steers native/authed
 * users appropriately. This layout only owns chrome: it hides native stack headers (the marketing
 * pages render their own <MarketingShell> nav) and sets per-route browser tab titles.
 */
import { Stack } from 'expo-router';
import { theme } from '../../src/theme';

export default function MarketingLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.color.bg.app },
      }}
    >
      <Stack.Screen name="index" options={{ title: 'Beam | The operating system for trades' }} />
      <Stack.Screen name="pricing" options={{ title: 'Pricing | Beam' }} />
      <Stack.Screen name="download" options={{ title: 'Download Beam' }} />
      <Stack.Screen name="legal/index" options={{ title: 'Legal Center | Beam' }} />
      <Stack.Screen name="legal/terms" options={{ title: 'Terms of Service | Beam' }} />
      <Stack.Screen name="legal/privacy" options={{ title: 'Privacy Policy | Beam' }} />
      <Stack.Screen name="legal/refunds" options={{ title: 'Refund & Return Policy | Beam' }} />
      <Stack.Screen name="legal/delete-account" options={{ title: 'Account Deletion | Beam' }} />
    </Stack>
  );
}
